import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import "../styles/main.css";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);

  return (
    <div className="navbar">
      <h1>Admin Dashboard</h1>
      <div className="navbar-right">
        <span>{user?.name}</span>
        <button onClick={logout}>Logout</button>
      </div>
    </div>
  );
};

export default Navbar;
